module.exports = __webpack_public_path__ + "static/img/8.c3baccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result/8.png
// module id = Pod5
// module chunks = 57